import * as moment from 'moment';
import { useState } from 'react';
import { Button, Glyphicon, InputGroup } from 'react-bootstrap';
import DialysisDurationLabel from './dialysis-duration-label';
import DialysisConfirmationModal from './dialysis-confirmation-modal';

interface IProps {
    dialysisStartDate: string,
    onChange: (newDate: string) => void
}

const DialysisDate = (props: IProps) => {
    const [dialysisConfirmation, setDialysisConfirmation] = useState<{ show: boolean, dialysisStartDate: string }>({ show: false, dialysisStartDate: '' });

    const handleShowDialysisConfirmation = () => {
        setDialysisConfirmation({ show: true, dialysisStartDate: props.dialysisStartDate });
    };

    const handleDialysisUpdateAndClose = (newDate: string) => {
        setDialysisConfirmation({ show: false, dialysisStartDate: '' });

        props.onChange(newDate);
    }

    const handleDialysisClose = () => {
        setDialysisConfirmation({ show: false, dialysisStartDate: '' });
    }

    const displayValue = moment(props.dialysisStartDate, 'YYYY-MM-DD').format('MM/DD/YYYY');

    return (
        <>
            <InputGroup>
                <InputGroup.Addon>{props.dialysisStartDate ? displayValue : 'Click on calendar ->'}</InputGroup.Addon>
                <DialysisDurationLabel dialysisStartDate={props.dialysisStartDate} />
                <InputGroup.Button><Button onClick={handleShowDialysisConfirmation}><Glyphicon glyph='calendar' /></Button></InputGroup.Button>
            </InputGroup>

            <DialysisConfirmationModal
                show={dialysisConfirmation.show}
                dialysisStartDate={dialysisConfirmation.dialysisStartDate}
                onUpdateAndClose={handleDialysisUpdateAndClose}
                onClose={handleDialysisClose}
            />
        </>
    );
}


export default DialysisDate;
